import Loading from './../../../Loading'
import { useEffect, useState } from 'react'

const FeaturesPost = ({ data, pullback, checked }) => {
  const [checkedState, setCheckedState] = useState([])

  useEffect(() => {
    if (checked) {
      setCheckedState(
        checked.map((item) => (typeof item === 'object' && item !== null ? item.id : item))
      )
    }
  }, [checked])

  const handleOnChangeCheckBoxs = (event) => {
    const val = parseInt(event.target.value)

    if (event.target.checked) {
      setCheckedState((prev) => [...prev, val])
      pullback((prev) => [...prev, val])
    } else {
      const arryCopy = [...checkedState]
      const index = arryCopy.indexOf(val)
      if (index > -1) {
        arryCopy.splice(index, 1)
        setCheckedState(arryCopy)
        pullback(arryCopy)
      }
    }
  }

  return (
    <div className="boxHolderPosts">
      <div className="titleBar">ویژگی‌ها</div>
      <div className="boxPost">
        <ul>
          {data ? (
            data.map((item) => (
              <li key={item.id}>
                <label htmlFor={`feature-${item.id}`}>
                  <input
                    type="checkbox"
                    value={item.id}
                    checked={checkedState.includes(item.id)}
                    onChange={handleOnChangeCheckBoxs}
                    name={`feature-${item.id}`}
                    id={`feature-${item.id}`}
                  />
                  {item.title}
                </label>
              </li>
            ))
          ) : (
            <Loading styles="mini" />
          )}
        </ul>
      </div>
    </div>
  )
}

export default FeaturesPost
